import React from "react";
import { LogRenderContext } from "../LogRenderer";
import Resumed from "../common/Resumed";
import { getMediaDetails } from "../utils";

const MediaResumed = () => {
  const { log } = React.useContext(LogRenderContext);
  const { name, id, updatedBy, updatedAt } = getMediaDetails(log);
  return <Resumed name={name} id={id} updatedBy={updatedBy} updatedAt={updatedAt} />;
};

export default MediaResumed;
